var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Tile',[_c('TileHeader',[_vm._t("header")],2),_c('TileBody',[_vm._t("body")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }